var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-caption",class:{ 'error--text': !!_vm.errorMessage, 'text--secondary': !_vm.errorMessage }},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage || _vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }